import { createBillingService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const BillingService = createBillingService(authorizedHttpClient, import.meta.env.VITE_API_URL)
